import api from './api';

export interface OnlineUserDto {
  user_id: string;
  display_name?: string | null;
  email?: string | null;
  avatar_url?: string | null;
  role?: string | null;
  last_seen: number;
  dnd?: boolean;
}

export async function sendHeartbeat(): Promise<void> {
  try {
    await api.post('/presence/heartbeat');
  } catch (e) {
    // cicho – heartbeat nie powinien spamować konsoli
  }
}

export async function fetchOnlineUsers(): Promise<OnlineUserDto[]> {
  const res = await api.get('/presence/online');
  if (res?.data?.success) return res.data.data as OnlineUserDto[];
  return [];
}

export async function setDnd(enabled: boolean): Promise<void> {
  try {
    await api.post('/presence/dnd', { enabled });
  } catch {}
}

// Dzienna aktywność użytkownika (bez zdarzeń technicznych)
export async function fetchUserDailyActivity(userId: string) {
  const today = new Date();
  const from = new Date(today.getFullYear(), today.getMonth(), today.getDate()).toISOString();
  const to = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1).toISOString();
  const res = await api.get('/activity', { params: { user_id: userId, from, to } });
  const rows = res.data?.data || [];
  return rows.filter((r: any) => !String(r.action||'').includes('presence') && !String(r.route||'').includes('/api/presence/heartbeat'));
}


